import { alpha, Box, darken, lighten, styled } from '@mui/material';
const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => ({
    borderTopColor: theme.palette.mode === 'dark'
        ? 'rgb(255, 255, 255)'
        : lighten(theme.palette.background.paper, 0.1),
    borderBottomColor: theme.palette.mode === 'dark'
        ? 'rgb(224, 224, 224)'
        : lighten(theme.palette.background.paper, 0.1),
    borderBottomWidth: theme.palette.mode === 'dark' ? '1px' : '0',
    borderLeftWidth: theme.palette.mode === 'dark' ? '1px' : '0',
    '&:hover': {
        background: theme.palette.mode === 'dark'
            ? 'rgba(47, 47, 47, 0.6)'
            : darken(theme.palette.background.paper, 0.1),
    },
    ...(selected && {
        background: theme.palette.mode === 'dark'
            ? 'rgb(47, 47, 47)'
            : darken(theme.palette.background.paper, 0.1),
        '&:hover': {
            background: theme.palette.mode === 'dark'
                ? 'rgba(47, 47, 47, 0.8)'
                : darken(theme.palette.background.paper, 0.15),
        },
    }),
}));
export const Item = styled(StyledBox)(({ theme, selected }) => ({
    transition: 'all 0.2s linear',
    '&:hover': {
        background: alpha(theme.palette.primary.main, 0.2),
    },
    '&:focus': {
        background: alpha(theme.palette.primary.main, 0.8),
        '& .MuiTypography-caption ': {
            color: lighten(theme.palette.error.contrastText, 0.2),
            fontWeight: 500,
        },
        '& .MuiTypography-subtitle1': {
            color: lighten(theme.palette.error.contrastText, 0.2),
        },
    },
    ...(selected && {
        background: alpha(theme.palette.primary.main, 0.3),
        '&:hover': {
            background: alpha(theme.palette.primary.main, 0.3),
        },
    }),
}));
export const Group = styled(StyledBox)(({ theme }) => ({
    transition: 'all 0.2s linear',
    background: alpha(theme.palette.primary.dark, 0.3),
    '&:hover': {
        background: alpha(theme.palette.primary.dark, 0.4),
    },
    '&:focus': {
        background: alpha(theme.palette.primary.dark, 0.8),
    },
}));
